import React from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import Responsive from '../assets/config/Responsive'

const PayButtonGrey: React.FC<{
  onClick?: (_: any) => void
  text?: string
  style?: React.CSSProperties
}> = ({ onClick, text = 'Pay', style }) => {
  return (
    <PayBtn style={style} type="button" onClick={onClick}>
      <span>{text}</span>
    </PayBtn>
  )
}
//
//
const PayBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  background-color: ${Colors.grey};
  height: 48px;
  min-width: 80px;
  transition: all 200ms ease-in-out;
  padding-left: 20px;
  padding-right: 20px;
  width: 112px;
  opacity: 1;

  /* open filter button icon */
  svg {
    height: 9px;
    margin-left: 10px;
  }

  span {
    color: ${Colors.primaryBlack};
    -webkit-text-fill-color: rgba(0, 0, 0, 1);
    -webkit-opacity: 1;
  }

  /* hover styles */
  &:hover {
    transition: all 200ms ease-in-out;
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    ${Responsive.mobile} {
      background-color: ${Colors.grey};
      border: none;
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        color: ${Colors.primaryBlack};
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
    }
    ${Responsive.tablet} {
      background-color: ${Colors.grey};
      border: none;
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        color: ${Colors.primaryBlack};
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
    }
  }
  &:active {
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    opacity: 0.9;
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
  }
  ${Responsive.mobile} {
    width: 100%;
  }
`

export default PayButtonGrey
